import i18n from "../i18n";
import { formatUnitValue } from "./displayUnits";

// Bodies a refused write can carry: a plain string, or a JSON object such as the
// R-L03 UsageLockErrorResponse { reason, floor, message }. Handing the object to a
// toast renders it as a React child, which throws and unmounts the whole app
// (a white page), so every caller turns the body into text through this first.
const LOCK_REASON_TEXT = {
  WORK_BELOW_LOCKED_FLOOR: (floor) =>
    i18n.t("ganttContext.workBelowLockedFloor", { floor: formatUnitValue(floor, "work") }),
  NONLABOR_COST_BELOW_LOCKED_FLOOR: (floor) =>
    i18n.t("ganttContext.costBelowLockedFloor", {
      floor: Number(floor).toLocaleString(i18n.resolvedLanguage || i18n.language, { maximumFractionDigits: 2 }),
    }),
};

export const serverErrorText = (data, fallback = "") => {
  if (typeof data === "string") return data || fallback;
  if (!data || typeof data !== "object") return fallback;
  const lockText = LOCK_REASON_TEXT[data.reason];
  if (lockText && Number.isFinite(data.floor)) return lockText(data.floor);
  return typeof data.message === "string" && data.message ? data.message : fallback;
};
